<template>
<div class="chapter">
<div class="inner_page">
<p class="ser" id="cover"><img alt="cover" src="images/AtomicRanch_cover.jpg" style="max-width:100%; height:100%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_toc_r1.vue?7d612c26